<script>

/**
 * Automodal 
 * 
 * Version 1.7
 * Soporte para args,
 * 
 * Version 1.6
 * Agregado el concepto de archetypeUsuarioexpedienteCFG, para administración de dependencias:
 *   Usuarioexpediente => Usuarioexpediente_hijo
 * 
 * Version 1.5
 * Remoción de DIV sobrante.
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'
import {extractForm} from '@/utils'
import expedienteitemQuicktable from '@/views/Expedienteitem/ExpedienteitemQuicktable.vue'
import monederoUserOverview from '@/views/Monedero/monedero-user-overview.vue'

import {archetype, archetypeUsuarioexpedienteCFG, automodalHandler} from './archetype'
import expedientecontenidoFormPage from '../Expedientecontenido/ExpedientecontenidoFormPage.vue'
import expedienteExternalLinkViewer from '@/views/Expedientes/ExpedienteExternalLinkViewer.vue'

export default {
    name: 'UsuarioexpedienteAutomodal',
    components: {
        expedienteitemQuicktable,
        expedientecontenidoFormPage,
        monederoUserOverview,
        expedienteExternalLinkViewer
    },
    props: {
        usuarioId: {
            type: [String, Number],
            required: true
        },
        conceptId: {
            type: [String, Number],
        },
        args: {
            type: Object,
            default: () => {return {}}
        }
    },
    data: () => {
        return {
            form: extractForm(archetype()),
            asides: {
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        getHandler() {
            return automodalHandler(this.form.id || this.conceptId)
        },
        readonly(){
            return  (('readonly' in this.form)) ? this.form.readonly : false;
        },
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype(), itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(this.handleItem(itemsRow));
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        archetypeUsuarioexpedienteCFG,
        triggerAutoUpdate(){
            this.$nextTick(() => {
                console.log('triggerAutoUpdate.getHandler', this.getHandler)
                this.$refs.automodal.define();
            })
        },
        beforeStore(form){
            form.usuario_id = this.usuarioId
            form.answers = this.$refs.expedienteContenidoFormPage.getExpedienteAnswers();
            console.log('beforeStore', form)
            return form;
        },
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    // case 'clientes_id':
                    //     if ((!!this.args) && (!!this.args.clientesId)) {
                    //         item.default = _.clone(this.args.clientesId);
                    //         item.type = undefined;
                    //     }
                    //     break;
                    default:
                        item.readonly = (this.readonly)? true : false;
                        break;
                }
            }
            return item;
        },

        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                _.forEach(asides, (aside, asideKey) => {
                    this.asides[asideKey] = aside;
                })
                // this.asides.administradores = asides.administradores
                // this.asides.distribuidores = asides.distribuidores
            }
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form"  ref="automodal" 
        :size="form.expediente_version_id? 'xl' : 'md'" 
        :label="form.id ? 'Actualizar expediente' : 'Nuevo expediente'" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler"  
        :allow-aside="form.expediente_version_id? true : false" 
        :allow-delete="!readonly"
        :form-key="formArchetypeMD5"
        :beforeStore="beforeStore"
        :args="args"
        :view-only="readonly"
        keep-on-success
        @successStoring="triggerAutoUpdate"
        @refresh="refresh" 
        @defined="checkAsides" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="8">
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
            <!-- <grid-input v-model="form.UsuarioexpedienteCfg" :archetype="archetypeUsuarioexpedienteCFG" /> -->
            <expedientecontenido-form-page v-if="form.expediente_version_id" 
                :expediente-version-id="form.expediente_version_id" 
                :usuario-expediente-id="form.id"
                :key="'expedientecontenido-form-page-' + form.expediente_version_id" 
                :readonly="readonly"
                ref="expedienteContenidoFormPage">
                <monedero-user-overview class="monedero-user-overview" :user-id="form.usuario_id || usuarioId"/>
                <expediente-external-link-viewer :key="'exp-id-' + form.id" :expediente-id="form.id" :expediente-hash="form.hash" class="p-2 pt-0" v-if="!readonly"/>
            </expedientecontenido-form-page>
            <b-jumbotron v-else header="Sin version de expediente" lead="Seleccione una versión de expediente para continuar." />
            <!-- <expedienteitem-quicktable/> -->
        </b-col>
        <b-col slot="bottom">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>

<style lang="less">
    .monedero-user-overview {
        background: linear-gradient(to bottom, #e4e7ea, #ffffff);
    }
</style>